import React from 'react';
import Policy from "../components/Policy";
import data from "./../components/Policy/compatibilityPolicy.json";
import {Helmet} from "react-helmet-async";

const CompatibilityPolicy = () => {

  return (
    <>
      <Helmet>
        <title>{data.pageTitle}</title>
        <meta name="description" content={data.pageDescription} />
      </Helmet>
      <Policy pageDate={data} />
    </>
  );
};

export default CompatibilityPolicy;